import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { replaceRolePermissions } from '@/api/access/accessApi';
import type { RoleDetail } from '@/api/access/accessApi.types';
import { buildRoleQueryKey, ROLES_QUERY_KEY } from '@/constants/queryKeys';

interface ReplaceRolePermissionsVariables {
  roleId: string;
  permissionIds: string[];
}

export function useReplaceRolePermissionsMutation(): UseMutationResult<
  RoleDetail,
  Error,
  ReplaceRolePermissionsVariables
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: function saveRolePermissions(variables: ReplaceRolePermissionsVariables) {
      return replaceRolePermissions(variables.roleId, variables.permissionIds);
    },
    onSuccess: function invalidateRoleCaches(updatedRole) {
      queryClient.invalidateQueries({ queryKey: ROLES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: buildRoleQueryKey(updatedRole.id) });
    },
  });
}
